/* eslint-disable max-len */
import React from "react";
import {Box} from "@mui/material";
import {PoliciesStyledBox} from "lib/components";

export default function About() {
  return (
    <PoliciesStyledBox>
      <Box sx={{fontSize: "1.2rem", width: {xs: "100%", sm: "90%"}}}>
        <p>
          <strong>CrewBook</strong> is your trusted digital companion for managing seafarer data and advancing your
          maritime career. Designed by maritime professionals for maritime professionals, our fully automated platform
          delivers:
        </p>
        <ul>
          <li>
            <strong>Secure, compliant data management:</strong> Your personal crew data is protected with bank-grade
            security, fully compliant with GDPR and ISO/IEC standards (27001:2013, 27017:2015, 27018:2019, 9001:2015,
            CSA STAR CCM v3.0.1).
          </li>
          <li>
            <strong>Real-time document verification:</strong> Instantly verify certificates with leading providers,
            authorities, and companies across the maritime industry, safeguarding against theft, compromise, and
            forgery.
          </li>
          <li>
            <strong>Career progression tools:</strong> Stay ahead with notifications about document expirations,
            personalized rank advancement opportunities based on your sea hours, and recommendations for certification
            trainings to reach your career goals.
          </li>
          <li>
            <strong>Global accessibility:</strong> Powered by AWS, CrewBook offers 99.999999999% uptime, ensuring your
            data is always available, no matter where your maritime journey takes you.
          </li>
          <li>
            <strong>Cost-effective efficiency:</strong> Manage your crew life with minimal expenses tailored to your
            rank, saving you time and money.
          </li>
        </ul>

        <p>
          All document requirements comply with international maritime standards, including but not limited to those set
          by the IMO, IMCA, and other relevant regulatory bodies, ensuring your confidence and compliance worldwide.
        </p>

        <p>Join the CrewBook community today and take control of your maritime career!</p>

        <p>
          <strong>Welcome Aboard!</strong>
        </p>
      </Box>
    </PoliciesStyledBox>
  );
}
